import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { ENTERPRISE_ADMIN_BASE } from '../../config/adminLayers';
import { PLATFORM_OPS_GROUPS, PLATFORM_OPS_SCREENS } from './platformOpsNav';

const BASE = `${ENTERPRISE_ADMIN_BASE}/platform-operations`;

export const PlatformOperationsLayout: React.FC = () => {
  const location = useLocation();
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `block rounded-lg px-3 py-2 text-sm transition-colors ${
      isActive
        ? 'bg-enterprise-accent/15 font-medium text-enterprise-accent'
        : 'text-enterprise-600 hover:bg-enterprise-100 hover:text-enterprise-900'
    }`;

  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div className="rounded-2xl border border-enterprise-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-bold uppercase tracking-widest text-violet-600">Platform operations</p>
        <h1 className="mt-2 text-2xl font-bold text-enterprise-900">Runtime &amp; Data Plane</h1>
        <p className="mt-2 max-w-3xl text-sm text-enterprise-600">
          Enterprise observability and operational control. Recommendations only — no autonomous optimization. Production
          queues, workers, and business logic remain unchanged until explicitly enabled.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-[240px_1fr]">
        <aside className="rounded-xl border border-enterprise-200 bg-white p-3 shadow-sm lg:max-h-[calc(100vh-12rem)] lg:overflow-y-auto">
          {PLATFORM_OPS_GROUPS.map((group) => (
            <div key={group} className="mb-4 last:mb-0">
              <p className="mb-1 px-3 text-xs font-bold uppercase tracking-wide text-enterprise-400">{group}</p>
              <nav className="space-y-0.5">
                {PLATFORM_OPS_SCREENS.filter((s) => s.group === group).map((screen) => (
                  <NavLink
                    key={screen.id}
                    to={screen.path.replace(BASE, '') || '.'}
                    end={screen.path === BASE}
                    className={linkClass}
                  >
                    {screen.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          ))}
        </aside>

        <main className="min-w-0">
          <Outlet context={{ pathname: location.pathname }} />
        </main>
      </div>
    </div>
  );
};
